(() => {
  const NOTE_PREFIX = 'WULT_PROFILE:';

  /** @type {Record<string, [number, number]>} [minDigits, maxDigits] for national number */
  const PHONE_RULES = {
    '852': [8, 8], // Hong Kong
    '86': [11, 11], // Mainland China
    '853': [8, 8], // Macau
    '886': [9, 9], // Taiwan
    '82': [9, 11], // South Korea
    '81': [10, 11], // Japan
  };

  function nationalDigitsOnly(raw) {
    let d = String(raw || '').replace(/\D/g, '');
    while (d.startsWith('0') && d.length > 1) d = d.slice(1);
    return d;
  }

  function normalizePhone(dialCode, rawNational) {
    const dial = String(dialCode || '').replace(/\D/g, '');
    if (!dial) return { ok: false, normalized: '' };

    const national = nationalDigitsOnly(rawNational);
    if (!national) return { ok: false, normalized: '' };

    const rule = PHONE_RULES[dial] || DEFAULT_RULE;
    const [min, max] = rule;
    if (national.length < min || national.length > max) {
      return { ok: false, normalized: '' };
    }

    return { ok: true, normalized: `+${dial}${national}` };
  }

  function removeExistingWultProfile(note) {
    const lines = String(note || '').split(/\r?\n/);
    const filtered = lines.filter((line) => !line.trim().startsWith(NOTE_PREFIX));
    return filtered.join('\n').trim();
  }

  function appendWultProfile(note, { gender, birthday, phone }) {
    const base = removeExistingWultProfile(note);
    const profileLine = `${NOTE_PREFIX} gender=${gender || ''}; birthday=${birthday || ''}; phone=${phone || ''}`;

    if (!base) return profileLine;
    return `${base}\n${profileLine}`;
  }

  function setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, message) {
    if (!phoneEl || !phoneErrorEl) return;
    if (message) {
      phoneEl.classList.add('input--error');
      phoneEl.setAttribute('aria-invalid', 'true');
      if (comboEl) comboEl.classList.add('register__phone-combo--error');
      phoneErrorEl.textContent = message;
      phoneErrorEl.hidden = false;
    } else {
      phoneEl.classList.remove('input--error');
      phoneEl.removeAttribute('aria-invalid');
      if (comboEl) comboEl.classList.remove('register__phone-combo--error');
      phoneErrorEl.textContent = '';
      phoneErrorEl.hidden = true;
    }
  }

  function setFieldError(input, errorEl, message) {
    if (!input || !errorEl) return;
    if (message) {
      input.classList.add('input--error');
      input.setAttribute('aria-invalid', 'true');
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      input.classList.remove('input--error');
      input.removeAttribute('aria-invalid');
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function getI18n(selector) {
    const el = document.querySelector(selector);
    return el ? String(el.textContent || '').trim() : '';
  }

  function init() {
    const form = document.getElementById('RegisterForm');
    if (!form) return;

    const genderEl = form.querySelector('[data-register-gender]');
    const birthdayEl = form.querySelector('[data-register-birthday]');
    const countryEl = form.querySelector('[data-register-phone-country]');
    const phoneEl = form.querySelector('[data-register-phone]');
    const comboEl = form.querySelector('[data-register-phone-combo]');
    const noteEl = form.querySelector('#RegisterForm-note[name="customer[note]"]');
    const phoneErrorEl = form.querySelector('#RegisterForm-phone-error');
    const consentEl = form.querySelector('[data-register-consent]');
    const consentErrorEl = form.querySelector('#RegisterForm-consent-error');

    if (!phoneEl || !noteEl) return;

    const invalidPhoneMsg =
      phoneEl.getAttribute('data-error-invalid-phone') ||
      getI18n('[data-i18n-phone-error-invalid]') ||
      'Please enter a valid phone number for the selected country or region.';

    const requiredPhoneMsg =
      phoneEl.getAttribute('data-error-required') ||
      getI18n('[data-i18n-phone-error-required]') ||
      'Phone number is required.';

    const requiredConsentMsg =
      (consentEl && consentEl.getAttribute('data-error-required')) ||
      getI18n('[data-i18n-consent-error-required]') ||
      'Please agree to the Terms and Privacy Policy.';

    phoneEl.addEventListener('input', () => {
      setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, '');
    });
    if (countryEl) {
      countryEl.addEventListener('change', () => {
        setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, '');
      });
    }
    if (consentEl) {
      consentEl.addEventListener('change', () => {
        setFieldError(consentEl, consentErrorEl, '');
      });
    }

    form.addEventListener(
      'submit',
      (e) => {
        const gender = genderEl ? String(genderEl.value || '').trim() : '';
        const birthday = birthdayEl ? String(birthdayEl.value || '').trim() : '';
        const dialCode = countryEl ? String(countryEl.value || '').trim() : '852';
        const rawNational = String(phoneEl.value || '').trim();

        if (!rawNational) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, requiredPhoneMsg);
          phoneEl.focus();
          return;
        }

        const normalizedPhone = normalizePhone(dialCode, rawNational);
        if (!normalizedPhone.ok) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, invalidPhoneMsg);
          phoneEl.focus();
          return;
        }

        if (consentEl && !consentEl.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          setFieldError(consentEl, consentErrorEl, requiredConsentMsg);
          consentEl.focus();
          return;
        }

        if (normalizedPhone.normalized) {
          const storedNational = nationalDigitsOnly(rawNational);
          phoneEl.value = storedNational;
        }
        setPhoneFieldError(phoneEl, phoneErrorEl, comboEl, '');
        if (consentEl) setFieldError(consentEl, consentErrorEl, '');

        noteEl.value = appendWultProfile(noteEl.value, {
          gender,
          birthday,
          phone: normalizedPhone.normalized,
        });
      },
      { capture: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
